<template>
    <el-drawer title="限制观演人" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close" append-to-body>
        <div class="drawer-content">
            <div class="page-filter-box">
				<el-row :gutter="20">
					<el-col :span="24">
						<div>限制方式：</div>
						<el-radio-group v-model="status">
							<el-radio :label="0" class="MT10">不限制观演人</el-radio><br><br>
							<el-radio :label="1" class="MT10">仅限购票人观演：绑定观演人时只能选择账号本身的实名信息</el-radio><br><br>
							<el-radio :label="2" class="MT10">自定义观演人：只能绑定下方观演人库中的实名信息</el-radio><br><br>
							<el-radio :label="3" class="MT10">限制学生认证观演人：只能选择完成学生认证的观演人</el-radio>
						</el-radio-group>
					</el-col>
				</el-row>
                <el-row :gutter="20" class="MT20" v-if="status == 2">
                    <el-col :span="14">
                        <el-input v-model="params.searchValue" size="small">
                            <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                                <el-option label="按证件编号查询" :value="1"></el-option>
                                <el-option label="按证件姓名查询" :value="2"></el-option>
                            </el-select>
                        </el-input>
                    </el-col>
                    <el-col :span="10" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
                </el-row>
            </div>
			<template v-if="status == 2">
				<div class="page-btns-box">
					<el-button v-if="$utils.have('/activityTicketWhite/remove')" type="primary" size="small" @click="out('', 1)"
						icon="el-icon-remove-outline">批量移除观演人</el-button>
					<el-button v-if="$utils.have('/activityTicketWhite/addCommonPerformer')" type="primary" size="small"
						@click="$refs.addUserlist.show(itemData)"
						icon="el-icon-circle-plus-outline">添加观演人</el-button>               
					<el-button v-if="$utils.have('/activityTicketWhite/importCommonPerformer')" type="primary" size="small"
						@click="$refs.importWhitelist.show(itemData)" icon="el-icon-upload2">导入观演人</el-button>	
				</div>
				<div class="page-list-box">
					<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
						@selection-change="handleSelectionChange">
						<el-table-column type="selection"></el-table-column>
						<el-table-column prop="documentType" label="证件类型">
							<template slot-scope="scope">
								{{documentType.get(scope.row.documentType)}}
							</template>
						</el-table-column>
						<el-table-column prop="documentNumber" label="证件编号"></el-table-column>
						<el-table-column prop="documentName" label="证件姓名"></el-table-column>
						<el-table-column fixed="right" label="操作" width="100">
							<template slot-scope="scope">
								<el-button v-if="$utils.have('/activityTicketWhite/remove')" type="text" size="small"
									@click="out(scope.row, 2)">移除观演人</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-if="data" class="page-pagination-box">
					<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
						:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
						layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
					</el-pagination>
				</div>
			</template>
        </div>
        <div class="drawer-footer">
			<el-button type="primary" :loading="btnLoading" @click="btnFun()"
			    >提 交</el-button
			>
            <el-button @click="close">关闭</el-button>
        </div>
        <add-userlist ref="addUserlist" @onUpdate="getDataList()"></add-userlist>
        <import-userlist ref="importWhitelist" @onUpdate="reset()"></import-userlist>
    </el-drawer>
</template>

<script>
import addUserlist from './add-userlist.vue';
import ImportUserlist from './import-userlist.vue';
import { downloadFileTmp } from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    pageSize: 10,
    searchType: 1,
    searchValue: '',
	
	
}
export default {
    components: { addUserlist, ImportUserlist },
    data() {
        return {
            drawerShow: false,
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
            },
            itemData:null,
            userListIds: [],
            listLoading: false,
            downLoading: false,
			btnLoading: false,
			status:0
        }
    },
	computed:{	   
	    documentType(){
	        return new Map([
	            [1,'身份证'],
	            [2,'港澳居民来往内地通行证'],
	            [3,'台湾居民来往大陆通行证'],
	            [4,'护照'],
                [5,'外国人永久居留身份证'],
                [6,'港澳台居民居住证']
	        ])
	    }
	},
    methods: {
        close() {
            this.params = {
                ...defaultParams,
            };
            this.data=null;
            this.dataList = [];
            this.whiteListIds = [];
            this.drawerShow = false;
        },
        show(item) {
			this.itemData = item
            this.drawerShow = true;
			this.getType()
			this.getDataList()
        },
		getType(){
			this.$request({
			    url: "/activityTicketWhite/commonPerformerInfoVO",
			    method: "POST",
			    params: {
			        ticketId:this.itemData.id
			    },
			})
			.then((res) => {
				const { state, msg, result } = res.data;
				if (state == 1 ) {
					this.status = result
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			    
		},
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                goodsId: this.itemData.activityId,
                ticketId: this.itemData.id
            }
            this.$request({
                url: "/activityTicketWhite/commonPerformerListVO",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.userListIds = val.map(v => v.id);
        },
        //移出白名单 type== 1 批量移除 type==2 是单个的移除
        out(data, type) {
            if (type == 1 && this.userListIds.length < 1) {
                return this.$message.warning('请选择需要移除的用户');
            } else {
                const _msg = type == 1 ?  '注意：如果有门票已经绑定了这些观演人，系统不会对门票进行处理，请人工联系用户协商解决，确认移除后立即生效！' : '注意：如果有门票已经绑定了该观演人，系统不会对门票进行处理，请人工联系用户协商解决，确认移除后立即生效！';
				const _title = type == 1 ? '是否确认移除观演人？' : `是否确认移除${data.documentName}？`
                var _arryids = [];
                if (type == 1) {
                    _arryids = this.userListIds
                } else {
                    _arryids.push(data.id)
                }

                this.$confirm(_msg, _title, {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/activityTicketWhite/commonPerformerEdit',
                        method: 'POST',
                        data: {                            
                            ticketId: this.itemData.id,
                            removeIds: _arryids,
							isCommonPerformerList:this.status
                        },
                    }).then(res => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                }).catch(() => { })
            }

        },
       
		//提交数据
		btnFun(){
			this.btnLoading = true;
			this.params = {
			    ...this.params,
			    goodsId: this.itemData.activityId,
			    ticketId: this.itemData.id
			}
			this.$request({
			    url: '/activityTicketWhite/commonPerformerEdit',
			    method: 'POST',
			    data: {
					isCommonPerformerList:this.status,
					ticketId: this.itemData.id,
			    },
			})
			    .then((res) => {
			        const { state, msg, result } = res.data;
			        if (state == 1) {
						this.btnLoading = false;
						this.$emit("onUpdate");
			            this.getDataList();
						this.$message.success('操作成功');
						this.close()
						
			        } else {
			            this.$message.error(msg || '请求失败');
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
			    .finally(() => {
			        this.listLoading = false;
			    });
		}
    }
}
</script>

<style lang="scss" scoped></style>